module.exports = __webpack_public_path__ + "static/media/vn.076d5956.svg";